export enum SettingsAction {
  GET_SETTINGS = 'SETTINGS/GET_SETTINGS',
  SAVE_SETTINGS = 'SETTINGS/SAVE_SETTINGS',
  CHANGE_PASSWORD = 'SETTINGS/CHANGE_PASSWORD',
  MOBILE_APPLICATION_DICTIONARY_OPERATION = 'SETTINGS/MOBILE_APPLICATION_DICTIONARY_OPERATION',
  TABLE_CONFIG = 'SETTINGS/TABLE_CONFIG',
  CHANGE_FOCUS_ROW = 'SETTINGS/CHANGE_FOCUS_ROW'
}

